// src/components/Footer/Footer.jsx
import { useTranslation } from 'react-i18next';
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
	
	  <a href="/privacy" className={styles.privacyLink}>
        {t('footer.privacy')}
      </a>
	
	
      <div className={styles.text}>
        &copy; {currentYear} {t('footer.brand')} - {t('footer.rights')}
      </div>


    </footer>
  );
};

export default Footer;
